// /**
//  *  RE CAPTCHA
//  */
// function loadRecaptcha() {
//     grecaptcha.execute(recaptchaKey,
//         { action: 'contact' }).then(function (token) {
//         var recaptchaResponse = document.getElementById('contact_recaptcha');
//         recaptchaResponse.value = token;
//     });
// }
// if ($('#g-recaptcha').length > 0) {
//     grecaptcha.ready(function () {
//         loadRecaptcha();
//     });
// }
//
//
// /**
//  *  FORM CONTATTI
//  */
// $(document).on('submit', 'form.contacts-form', function (e) {
//     e.preventDefault();
//
//     var form = $(this);
//     var isContactPage = $(this).hasClass('isContactPage') ? '1' : '0';
//
//     $.post('/contacts/send?cp='+isContactPage, form.serializeArray(), function (response) {
//         $('.contacts-form').html(response.html);
//
//         if(response.result) {
//
//             window.dataLayer =  window.dataLayer || [];
//             dataLayer.push({
//                 'event': 'submit',
//                 'form_submitted': 'contacts'
//             });
//             fbq_trackCustom('submit__contacts');
//
//             $('#contact_success_modal').modal('show');
//         }
//         else {
//             if($('#contact_type_1').prop('checked')) {
//                 $('#contact_name').attr('placeholder', 'Struttura *');
//                 $('#contact_last_name').attr('placeholder', 'Referente *');
//             }
//             else {
//                 $('#contact_name').attr('placeholder', 'Nome *');
//                 $('#contact_last_name').attr('placeholder', 'Cognome *');
//             }
//
//             loadRecaptcha();
//         }
//     });
// });
//
// $(document).ready(function() {
//     $('[name="contact[type]"]').change(function () {
//         if($(this).val() == '2') {
//             $('#contact_name').attr('placeholder', 'Struttura *');
//             $('#contact_last_name').attr('placeholder', 'Referente *');
//         }
//         else {
//             $('#contact_name').attr('placeholder', 'Nome *');
//             $('#contact_last_name').attr('placeholder', 'Cognome *');
//         }
//     });
// });


/**
 *  EKKO LIGHTBOX
 */
$(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox({
        leftArrow: '<i class="fa fa-chevron-circle-left text-left"></i>',
        rightArrow: '<i class="fa fa-chevron-circle-right text-right"></i>'
    });
});



/**
 *  RESPONSIVE TABLE
 */
$(document).ready(function() {
    if ($('.table').length) {
        $( ".table" ).wrap( "<div class='table-responsive'></div>" );
    }
});





// function expoModal() {
//     if (!getCookie('expoModal_2024')) {
//        setTimeout(function () {
//             $('#event_modal').modal('show');
//             setCookie('expoModal_2024', 1, 1);
//         }, 1000);
//     }
// }

// $(document).ready(function() {
//     expoModal();
// });
